import { useState, useEffect } from "react";
import cropr, { Backbone } from "../../shared/utils/cropr";
import { BalanceAggregateType } from "./DashboardFinancial";
import { getUrl } from "./utils";
import useCachedUrlData from "../../shared/hooks/useCachedUrlData";
import _ from "underscore";

export type RowVal = string | number | null;
type Row = [string, RowVal, RowVal, RowVal, RowVal, RowVal, number];

export interface CellMeta {
  price?: string;
  revenue?: string;
  record?: any;
  link?: any;
  index?: number[];
  ids?: number[];
}

export interface PageDataData {
  name: string;
  header: Array<string | null>;
  summary?: Array<string | null>;
  rows: Row[];
  meta?: Record<number, Record<number, CellMeta>>;
  total?: number;
}

export interface PageDataCode {
  code: string;
  data: PageDataData;
}

export interface PageData {
  name: string;
  data: PageDataCode[];
  cropfields?: Array<number>;
}

export interface FinancialData {
  title: string;
  pages: PageData[];
}

type useFinancialDataError = any;

export interface UseFinancialDataResult {
  data?: FinancialData;
  error: useFinancialDataError;
}

export interface useFinancialDataProps {
  aggregate?: BalanceAggregateType;
  cropFieldId?: number;
}

/**
 * Pfff, we really need Redux. Makes it so much easier
 * state: {financial: {aggregate: FinancialData}}
 * dispatch(updateFinancial()) instead our own hacky-backbony
 * */
let cacheKey: Backbone.Model; // singleton, otherwise it gets updated
let initialVersion: string;
export function update() {
  // this is hacking! Please don't copy this pattern. Introduce redux
  cropr.cache = {};
  console.log("update financial data");
  cacheKey?.set({ version: "update_" + new Date().getTime() });
}
const debouncedUpdate = _.debounce(update, 1000);

const useFinancialData = ({
  aggregate = 0,
  cropFieldId,
}: useFinancialDataProps): UseFinancialDataResult => {
  if (!initialVersion) {
    initialVersion = String(new Date().getTime());
  }
  const [version, setVersion] = useState(initialVersion);
  if (!cacheKey) {
    cacheKey = new Backbone.Model({ version });
  }
  useEffect(function () {
    const v = () => setVersion(cacheKey.get("version"));
    cacheKey.on("change", v);
    cropr.records.on("change add remove", debouncedUpdate); // todo alleen bij on-server updates, check push-mechanisme
    return () => {
      cacheKey.off("change", v);
      cropr.records.off("change add remove", debouncedUpdate);
    };
  }, []);
  const url = `${getUrl({ cropFieldId, aggregate })}?type=json&cacheKey=${version}`;
  return useCachedUrlData<FinancialData>(url);
};

export default useFinancialData;
